module.exports = __webpack_public_path__ + "static/media/ico-action-items.7f4858aa.svg";